import { __assign } from "tslib";
import { INFO, INFO_CONTROLLERS } from './controllers/info';
import { OVERLAY, OVERLAY_CONTROLLERS } from './controllers/overlay';
import { VIDEO, VIDEO_CONTROLLERS } from './controllers/video';
import { GALLERY, GALLERY_CONTROLLERS } from './controllers/gallery';
import { FULLSCREEN, FULLSCREEN_CONTROLLERS } from './controllers/fullscreen';
export var PRIVATE_CONTROLLERS = {
    INFO: INFO,
    OVERLAY: OVERLAY,
    VIDEO: VIDEO,
    GALLERY: GALLERY,
    FULLSCREEN: FULLSCREEN
};
var MIGRATION_MAP = __assign(__assign(__assign(__assign(__assign({}, INFO_CONTROLLERS), OVERLAY_CONTROLLERS), VIDEO_CONTROLLERS), GALLERY_CONTROLLERS), FULLSCREEN_CONTROLLERS);
export function migratePrivateControllers(originalOptions) {
    var options = __assign({}, originalOptions);
    Object.keys(MIGRATION_MAP).forEach(function (key) {
        var value = originalOptions[key];
        if (value !== undefined) {
            var handler = MIGRATION_MAP[key];
            if (typeof handler === 'function') {
                options = __assign(__assign({}, options), (handler(value, options) || {}));
            }
            else {
                options[handler] = value;
            }
        }
    });
    return options;
}
//# sourceMappingURL=index.js.map